import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import {
  toCategoryLink,
  toLandingPageLink,
  toSubcategoryLink,
} from 'lib/links';

import { useTopbar } from 'providers/TopbarProvider';

import CATEGORY from 'constants/category';
import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const SitemapGroupList = ({
  categories,
  lastCategorySlugGroupedBySubcategories,
  ...rest
}) => {
  const { highlightedLandings } = useTopbar();

  return (
    <Flex {...rest}>
      <NextLink href={LINKS.SITEMAP} passHref>
        <Link>{CATEGORY.SEE_ALL_CATEGORIES}</Link>
      </NextLink>
      {categories?.map(({ categoryName, categoryUrl, subcategories = [] }) => (
        <Flex key={categoryName}>
          <NextLink href={toCategoryLink(categoryUrl)} passHref>
            <Link>{categoryName}</Link>
          </NextLink>
          {categoryUrl === lastCategorySlugGroupedBySubcategories && (
            <>
              <NextLink
                href={toLandingPageLink(
                  'dia-do-consumidor',
                  LANDINGS.TYPES.INSTITUTIONAL
                )}
                passHref
              >
                <Link>Dia do Consumidor</Link>
              </NextLink>
              {highlightedLandings.length > 0 && (
                <>
                  <Text bold>Páginas Especiais</Text>
                  {highlightedLandings.map(
                    ({ landingId, landingName, landingSlug, landingType }) =>
                      landingName && (
                        <NextLink
                          href={toLandingPageLink(landingSlug, landingType)}
                          key={landingId}
                          passHref
                        >
                          <Link>{landingName}</Link>
                        </NextLink>
                      )
                  )}
                </>
              )}
            </>
          )}
          {subcategories.length > 0 && (
            <Flex>
              {subcategories.map(({ subcategoryName, subcategoryParam }) => (
                <NextLink
                  href={toSubcategoryLink(subcategoryParam)}
                  key={subcategoryParam}
                  passHref
                >
                  <Link>{subcategoryName}</Link>
                </NextLink>
              ))}
            </Flex>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

SitemapGroupList.defaultProps = {
  categories: null,
};

SitemapGroupList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      categoryName: PropTypes.string.isRequired,
      categoryUrl: PropTypes.string.isRequired,
      groupId: PropTypes.number.isRequired,
      groupName: PropTypes.string.isRequired,
      subcategories: PropTypes.array.isRequired,
    }).isRequired
  ),
  lastCategorySlugGroupedBySubcategories: PropTypes.string.isRequired,
};

export default SitemapGroupList;
